export default __webpack_public_path__ + "static/media/solucao-08.01fdad27.webp";